export default __webpack_public_path__ + "static/media/Frostfire Cowl.733ebbf7.jpg";